<template>
	<v-list-item three-line>
		<v-list-item-icon>
			<div v-if="collaboration.type == 'poll'">
				<v-icon>mdi-account-group</v-icon>
				<v-badge :content="collaboration.response_count " color="accent"></v-badge>
			</div>
			<div v-if="collaboration.type == 'delegation'">
				<v-icon >mdi-clipboard-flow</v-icon>
			</div>
		</v-list-item-icon>
		<v-list-item-content>
			<v-list-item-title>
				{{collaboration.name}}
			</v-list-item-title>
			<!-- <v-list-item-subtitle>{{collaboration.message}}</v-list-item-subtitle> -->
			<v-list-item-subtitle class="mt-4">
				<v-chip x-small dark color="grey" class="mr-2">
					{{ mwTranslate( "type", collaboration.type) }}
				</v-chip>
				<v-chip x-small dark :color="statusColor" class="mr-2">
					{{ mwTranslate( "status", collaboration.status) }}
				</v-chip>
				<v-chip v-if="collaboration.type == delegation" x-small dark class="mr-2" :color="completionRateColor">
					{{ collaboration.completion_rate || '0' }}%
				</v-chip>
				<p class="small mt-4 mb-0">
					<DateNote :date="collaboration.updated" name="Last updated" format="DD/MM/yyyy"></DateNote>
				</p>
			</v-list-item-subtitle>
		</v-list-item-content>
		<v-list-item-icon>
			<v-btn color="primary2" fab small @click="linkTo(`collaboration/${collaboration.id}`)">
				<v-icon color="white">mdi-arrow-right-bold</v-icon>
			</v-btn>
		</v-list-item-icon>
	</v-list-item>

</template>

<style lang="less">
	
</style>

<script type="text/javascript">
	import Vuex from "vuex";
	import DateNote from "@/components/elements/DateNote"
	export default {
		name: "CollaborationListItem", 
		props: {
			id: {type: String}
		},
		data: () => {
			return {

			}
		},
		components: {
			DateNote
		},
		computed: {
			...Vuex.mapState({
				groups: state => state.groups || [],
				collaborations: state => state.collaborations || [],
			}),
			collaboration(){
				var id = this.id;
				return this.collaborations.find( c => c.id == id )
			}, 
			statusColor(){
				if( this.collaboration.status == "in_progress" ){
					return "primary2"
				}
				if( this.collaboration.status == "complete" ){
					return "green"
				}
				return "grey"
			}, 
			completionRateColor(){
				if( this.collaboration.completion_rate > 70 ){
					return "green"
				}
				if( this.collaboration.completion_rate > 30 ){
					return "primary2"
				}
				if( this.collaboration.completion_rate > 30 ){
					return "orange"
				}
				return "grey"
			},
			started(){
				return this.collaboration.status !== "not_started"
			}
		},
		// methods: {
		// }
		// created(){
			
		// }

	}
</script>